import values from "lodash/values";
import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { keyboardEventPassthroughHandler } from "utils/keyboardEventPassthroughHandler";

const LEFT = "LEFT";
const RIGHT = "RIGHT";
export const CloseButtonPosition = {
  LEFT,
  RIGHT,
};

export default class CloseBox extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    closePosition: PropTypes.oneOf(values(CloseButtonPosition)).isRequired,
    hideClose: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
  };

  render() {
    const className = classnames("close-box", {
      [this.props.className]: this.props.className,
    });
    return (
      <div className={className}>
        {!this.props.hideClose && (
          <div
            className={classnames(
              "close-button font-size--button--small",
              this.props.closePosition === CloseButtonPosition.LEFT
                ? "close-button--left"
                : "close-button--right",
            )}
            role="button"
            aria-label={this.props.title}
            onClick={this.props.onClose}
            onKeyUp={keyboardEventPassthroughHandler(this.props.onClose)}
            tabIndex={0}
          >
            <i className="icon icon-Close2" />
          </div>
        )}
      </div>
    );
  }
}
